import axios from "axios";
export const INVOICES_URL = process.env.REACT_APP_API_BASE_URL + "invoice";
export const CUSTOMERS_DEBT_URL =
  process.env.REACT_APP_API_BASE_URL + "customer-statistics";

// CREATE =>  POST: add a new product to the server
export function createProduct(product) {
  return axios.post(INVOICES_URL, { product });
}

// READ
export function getAllProducts() {
  return axios.get(INVOICES_URL);
}

export function getProductById(productId) {
  return axios.get(`${INVOICES_URL}/${productId}`);
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findProducts(queryParams) {
  //return axios.post(`${INVOICES_URL}`, { queryParams });

  let searchTerms = null;

  if (queryParams.filter.searchTerms != undefined) {
    searchTerms = queryParams.filter.searchTerms;
  }
  return axios.get(
    INVOICES_URL +
      "/" +
      queryParams.pageNumber +
      "/" +
      queryParams.pageSize +
      "/" +
      searchTerms
  );
}
export function findCustomerDebts(queryParams) {
  //return axios.post(`${INVOICES_URL}`, { queryParams });

  return axios.get(CUSTOMERS_DEBT_URL);
}

// UPDATE => PUT: update the procuct on the server
export function updateProduct(product) {
  return axios.put(`${INVOICES_URL}/${product.id}`, { product });
}

// UPDATE Status
export function updateStatusForProducts(ids, status) {
  return axios.post(`${INVOICES_URL}/updateStatusForProducts`, {
    ids,
    status,
  });
}

// DELETE => delete the product from the server
export function deleteProduct(productId) {
  return axios.delete(`${INVOICES_URL}/${productId}`);
}

// DELETE Products by ids
export function deleteProducts(ids) {
  return axios.post(`${INVOICES_URL}/deleteProducts`, { ids });
}
